import { render, staticRenderFns } from "./logisticstatus.vue?vue&type=template&id=644179c8"
import script from "./logisticstatus.vue?vue&type=script&lang=js"
export * from "./logisticstatus.vue?vue&type=script&lang=js"
import style0 from "./logisticstatus.vue?vue&type=style&index=0&id=644179c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports